package com.fantasytenis.shared.domain.admin.usecases

import com.fantasytenis.shared.core.network.ApiResponse
import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.data.admin.api.AdminApi
import com.fantasytenis.shared.data.admin.dto.PlatformConfigDto
import com.fantasytenis.shared.data.admin.dto.UpdatePlatformConfigRequest

/**
 * Use case to get platform configuration.
 */
class GetPlatformConfigUseCase(
    private val adminApi: AdminApi
) {
    suspend operator fun invoke(): Result<PlatformConfigDto> {
        return when (val response = adminApi.getConfig()) {
            is ApiResponse.Success -> {
                // Update SharedData with the config
                SharedData.showPaidGames.value = response.data.showPaidGames
                Result.success(response.data)
            }
            is ApiResponse.Error -> Result.failure(Exception(response.message))
        }
    }
}

/**
 * Use case to update platform configuration.
 * Only admins/superadmins can use this.
 */
class UpdatePlatformConfigUseCase(
    private val adminApi: AdminApi
) {
    suspend operator fun invoke(showPaidGames: Boolean): Result<PlatformConfigDto> {
        val request = UpdatePlatformConfigRequest(showPaidGames = showPaidGames)

        return when (val response = adminApi.updateConfig(request)) {
            is ApiResponse.Success -> {
                // Update SharedData with the new config
                SharedData.showPaidGames.value = response.data.showPaidGames
                Result.success(response.data)
            }
            is ApiResponse.Error -> Result.failure(Exception(response.message))
        }
    }
}
